import { render } from "./EventDetailedPage.vue?vue&type=template&id=650e0bb8&scoped=true"
import script from "./EventDetailedPage.vue?vue&type=script&lang=js"
export * from "./EventDetailedPage.vue?vue&type=script&lang=js"

import "./EventDetailedPage.vue?vue&type=style&index=0&id=650e0bb8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650e0bb8"]])

export default __exports__